export default __webpack_public_path__ + "static/media/info-cake.131e1d89.png";